module.exports = __webpack_public_path__ + "img/NOT SURE.jpg";